import KeyInfo from './key_info';

export default KeyInfo;
